module.exports = __webpack_public_path__ + "img/demo.20d19562.svg";